import Vue from 'vue'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
Vue.component('PDFViewer', PDFViewer)
